import type { Brand, BrandConfig, BrandKey } from "./types/brand";

const defaultConfig: BrandConfig = {
  name: "Wayflyer",
  supportEmail: "support@wayflyer.com",
  statementsEmail: "statements@wayflyer.com",
  appDomain: "wayflyer.com",
  themeName: "wayflyer",
};

export const brandsConfig: { [key in BrandKey]: BrandConfig } = {
  wayflyer: defaultConfig,
};

const brandConfig = defaultConfig;

export const brand: Brand = { ...brandConfig, key: "wayflyer" };
